import { log, LOG_LEVELS } from '@common/config/app_logger';
import { useRef, useState } from 'react';

type Response = {
  paginationParams?: General.PaginationParams;
  [key: string]: any;
}

export const useRequestPaging = (requestFunction: (params: any) => Promise<Response>) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const paginationParams = useRef<General.PaginationParams>(null);

  const loadData = async (params?: any, initialRequest: boolean = false) => {
    setLoading(true);
    setError(null);
    try {
      const result = await requestFunction({ ...params, ...(initialRequest ? null : paginationParams.current) });
      paginationParams.current = result.paginationParams;
      return result;
    } catch (err) {
      log(LOG_LEVELS.ERROR, 'useRequestPaging:loadData', 'Error loading paged data', err);
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading, error, hasMore: !!paginationParams.current, loadData
  };
};
